import { hasMany, attr } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

export const CLASSIFICATION_CATEGORIES = {
  CATEGORY_SUBJECT: 'subject',
  CATEGORY_MEDIUM: 'medium',
  CATEGORY_INDUSTRY: 'industry',
};

export const CLASSIFICATION_SECTIONS = {
  SUBJECT: 'Subject',
  MEDIUM: 'Medium',
  INDUSTRY: 'Industry'
};

export const CLASSIFICATION_CATEGORY_ORDER = {
  [CLASSIFICATION_SECTIONS.SUBJECT]: 1,
  [CLASSIFICATION_SECTIONS.MEDIUM]: 2,
  [CLASSIFICATION_SECTIONS.INDUSTRY]: 3,
};

export const CLASSIFICATION_TYPES = {
  TYPE_DEFAULT: 1,
  TYPE_ADMIN_ONLY: 2,
  TYPE_USER_CUSTOM: 3,
};

class Classification extends ShModel {
  @attr('number') type;
  @attr('string') label;
  @attr('string') category;
  @attr('number') count;

  /* Only accessible when included from the projectdigest */
  @attr('boolean') isSourceAdmin;

  @hasMany('projectdigests', { async: false }) projectdigest;
}

export default Classification;
